module.exports = __webpack_public_path__ + "static/media/setting_logo.7fe45e1e.svg";